import httpService from "../Api/http.service";
import { getApiBaseUrl } from 'utils';

const triggerNotifyUser = (payload) => 
  httpService({
    url: getApiBaseUrl() + `/notify/user`,
    method: "put",
    data: payload
  });

const emailService = {
  triggerNotifyUser
};

export default emailService;
